import { t } from '@trimble/i18n';
import { PanelLayoutWithHeaderToggle } from '@trimble/ui-components/solidjs';
import { JSX, Show } from 'solid-js';

import {
  WorkspacesTabReferencesFilter,
  WorkspacesTabReferencesViewToggle,
  WorkspacesTabWorkspaceActions,
} from './WorkspacesTabHeaderControls';
import { WorkspacesTabDialogs } from './WorkspacesTabDialogs';
import { WorkspacesTabPanelContent } from './WorkspacesTabPanelContent';
import { useWorkspacesTab } from './useWorkspacesTab';

export const WorkspacesTab = (): JSX.Element => {
  const tab = useWorkspacesTab();

  return (
    <div data-testid="workspaces-tab" class="contents">
      <PanelLayoutWithHeaderToggle
        panelTitle={t('mobileMapping.fxWorkspace.title')}
        titleSectionRight={
          <Show when={tab.hasWorkspaces()}>
            <WorkspacesTabReferencesFilter
              referencesFilterMode={tab.referencesFilterMode()}
              onReferencesFilterChange={tab.handleReferencesFilterChange}
            />
          </Show>
        }
        rightActions={
          <>
            <Show when={tab.hasWorkspaces()}>
              <WorkspacesTabReferencesViewToggle
                referencesViewToggleIcon={tab.referencesViewToggleIcon()}
                referencesViewToggleTitle={tab.referencesViewToggleTitle()}
                onReferencesViewToggle={tab.handleReferencesViewToggle}
              />
            </Show>
            <WorkspacesTabWorkspaceActions
              hasActiveWorkspace={tab.hasActiveWorkspace()}
              onModifyWorkspaceData={tab.enterWorkspaceDataEditing}
              onDeleteWorkspace={tab.openDeleteDialog}
            />
          </>
        }
        content={
          <WorkspacesTabPanelContent
            isError={tab.isError()}
            isLoading={tab.isLoading()}
            hasWorkspaces={tab.hasWorkspaces()}
            hasWorkspaceReferences={tab.hasWorkspaceReferences()}
            activeWorkspace={tab.activeWorkspace()}
            workspaceOptions={tab.workspaceOptions()}
            nodes={tab.nodes()}
            childrenLoadStatus={tab.childrenLoadStatus()}
            onActiveWorkspaceChange={tab.handleActiveWorkspaceChange}
            onCreateWorkspace={tab.openCreateDialog}
          />
        }
      />
      <WorkspacesTabDialogs
        isCreateDialogOpen={tab.isCreateDialogOpen()}
        workspacePendingDelete={tab.workspacePendingDelete()}
        onCloseCreateDialog={tab.closeCreateDialog}
        onCloseDeleteDialog={tab.closeDeleteDialog}
      />
    </div>
  );
};
